import "./phrase.css";

export default function Phrase({hiddenPhraseLetters}) {
  return (
    <div className="phrase">
      {hiddenPhraseLetters.map((letter, index) => <div className="phrase__letter" key={index}>{letter}</div>)}
    </div>
  );
}
